import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  TextField,
  CircularProgress
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const BannerUploadModal = ({ open, onClose, onUpload, title = 'Upload de Banner' }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    link: ''
  });

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Selecione uma imagem');
      return;
    }

    if (!formData.title.trim()) {
      alert('Digite um título para o banner');
      return;
    }

    setUploading(true);
    try {
      const data = new FormData();
      data.append('image', selectedFile);
      data.append('title', formData.title);
      data.append('link', formData.link);
      data.append('active', '1');

      const response = await fetch(`${API_URL}/banners`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('@DeliveryAdmin:token')}`
        },
        body: data
      });

      const result = await response.json();
      
      if (response.ok) {
        alert('Banner criado com sucesso!');
        onUpload(result);
        handleClose();
      } else {
        alert(result.error || 'Falha ao criar banner');
      }
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
      alert('Falha ao fazer upload');
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    setPreview(null);
    setFormData({ title: '', link: '' });
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        minWidth: 500,
        maxWidth: 600
      }}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        
        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            label="Título do Banner"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            required
            sx={{ mb: 2 }}
          />
          
          <TextField
            fullWidth
            label="Link (opcional)"
            name="link"
            value={formData.link}
            onChange={handleInputChange}
          />
        </Box>
        
        <Box sx={{ 
          border: '2px dashed #ccc', 
          p: 3, 
          mb: 3, 
          textAlign: 'center',
          borderRadius: 1,
          cursor: 'pointer',
          '&:hover': {
            borderColor: '#999'
          }
        }}>
          {preview ? (
            <img 
              src={preview} 
              alt="Preview" 
              style={{ 
                maxWidth: '100%', 
                maxHeight: 200, 
                borderRadius: 1,
                objectFit: 'cover'
              }}
            />
          ) : (
            <Box>
              <CloudUploadIcon sx={{ fontSize: 48, color: '#ccc', mb: 2 }} />
              <Typography variant="body2" color="text.secondary">
                Clique para selecionar uma imagem
              </Typography>
            </Box>
          )}
        </Box>

        <input
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          style={{ display: 'none' }}
          id="banner-upload-input"
        />

        <label htmlFor="banner-upload-input">
          <Button
            variant="outlined"
            component="span"
            fullWidth
            sx={{ mb: 2 }}
          >
            {selectedFile ? selectedFile.name : 'Selecionar Imagem'}
          </Button>
        </label>

        {selectedFile && (
          <Button
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpload}
            disabled={uploading}
            fullWidth
          >
            {uploading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Enviando...
              </>
            ) : (
              'Fazer Upload'
            )}
          </Button>
        )}
      </Box>
    </Modal>
  );
};

export default BannerUploadModal;
